import { format, parseISO } from 'date-fns';

/**
 * Takes a date object and returns a formatted date string for the time
 * Options: clockAmPm - boolean - true for 12-hour clock, false for 24-hour clock
 * @param {*} time
 * @param {*} options
 * @returns
 */
export const formatTime = (time, options) => {
  const clockAmPm = !!options?.clockAmPm;
  const timeFormat = clockAmPm ? 'h:mm a' : 'H:mm';
  return format(time, timeFormat);
};

export const formatUTCDate = (utcDate) => {
  if (!utcDate) {
    return '';
  }

  const date = parseISO(utcDate);
  return format(date, 'MMMM dd');
};

export const formatUTCTime = (utcDate, options) => {
  if (!utcDate) {
    return '';
  }

  const date = parseISO(utcDate);
  return formatTime(date, options);
};
